module.exports = __webpack_public_path__ + "img/novotag_4.ab4dcb69.jpg";